import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UnitModel } from '../_models/unit.model';

import { environment } from '../../../../environments/environment';
import { UserService } from '../../auth/_services/user.service';

const API_UNIT_URL = '/api/unit';
const API_URL = environment.API_URL;


@Injectable({
  providedIn: 'root'
})
export class UnitService {

    unitList: any[];
    unitListChanged = new EventEmitter<any[]>();
    unitByFacilityProjection: string = [ "facility", "_id", "name" ].join(",");
    constructor(
      private readonly http: HttpClient,
      private readonly userService: UserService
    ) { }

    emptyUnit(){
      this.unitList = [];
      this.unitListChanged.emit([]);
    }

  getUnit(fields = null, observableFlag = false) {
      let url = API_URL + API_UNIT_URL;
      let httpParams = new HttpParams();

      if (fields) {
        httpParams = httpParams.set('fields', fields);
      }

      if (observableFlag) {
        return this.http.get(url, { params: httpParams, headers: this.userService.getHttpAuthHeader() });
      }

      this.http.get(url, { params: httpParams, headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
        this.unitList = data.data;
        this.unitListChanged.emit(data.data);
      });
    }
    getUnitByFacility(id: any, observableFlag = false, fields = '') {
      let url = API_URL + API_UNIT_URL + '?facility=' + id
      if (fields) {
        url += '&fields=' + fields
      }
      if(observableFlag){
        return this.http.get(url, {headers: this.userService.getHttpAuthHeader()});
      }
      this.http.get(url, {headers: this.userService.getHttpAuthHeader()}).subscribe((data: any) => {
        this.unitList = data.data;
        this.unitListChanged.emit(data.data);
      });
    }

  getUnitById(id: string, fields = "") {
    let url = API_URL + API_UNIT_URL
    if (id) {
      url = url + '?_id=' + id
    }
    if (fields) {
      url += '&fields=' + fields
    }
    return this.http.get(url, { headers: this.userService.getHttpAuthHeader() });
  }

    createUnit(u: Partial<UnitModel>, observableFlag = false) {
    let unit = {
        name: u.name.trim(),
        capacity: u.capacity.trim(),
        alertOwner: u.alertOwner,
        image: u.image,
        notes: u.notes,
        facility: u.facility,
        emailNotificationUsers: u.emailNotificationUsers,
        emailNotificationThresholdAlertsUsers: u.emailNotificationThresholdAlertsUsers,
        emailNotificationTrialRunUsers: u.emailNotificationTrialRunUsers,
        emailNotification: u.emailNotification || [],
        emailNotificationThresholdAlerts: u.emailNotificationThresholdAlerts || [],
        emailNotificationTrialRun: u.emailNotificationTrialRun || []
      }

      if(observableFlag){
        return  this.http.post<UnitModel>(API_URL + API_UNIT_URL, unit, { headers: this.userService.getHttpAuthHeader() });
      }

      this.http.post<UnitModel>(API_URL + API_UNIT_URL, unit, { headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
        this.userService.getCurrentUser();
        this.getUnitByFacility(unit.facility, false, this.unitByFacilityProjection);
      });
    }

    updateUnit(u: Partial<UnitModel>, observableFlag = false) {
      let unit = {
        _id: u._id,
        name: u.name.trim(),
        capacity: u.capacity.trim(),
        alertOwner: u.alertOwner,
        image: u.image,
        notes: u.notes,
        facility: u.facility,
        emailNotificationUsers: u.emailNotificationUsers,
        emailNotificationThresholdAlertsUsers: u.emailNotificationThresholdAlertsUsers,
        emailNotificationTrialRunUsers: u.emailNotificationTrialRunUsers,
        emailNotification: u.emailNotification || [],
        emailNotificationThresholdAlerts: u.emailNotificationThresholdAlerts || [],
        emailNotificationTrialRun: u.emailNotificationTrialRun || [],
        emailShutdownStartupNotification: u.emailShutdownStartupNotification,
        emailShutdownStartupNotificationUsers: u.emailShutdownStartupNotificationUsers,
        escalationDelayThreshold: u.escalationDelayThreshold,
        escalationEmails: u.escalationEmails || []
      }

      if(observableFlag){
        return this.http.put<UnitModel>(API_URL + API_UNIT_URL, unit, { headers: this.userService.getHttpAuthHeader() });
      }

      this.http.put<UnitModel>(API_URL + API_UNIT_URL, unit, { headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
        this.getUnitByFacility(unit.facility, false, this.unitByFacilityProjection);
      });
    }

    /* deleteUnit(id:string, callback?:any) {

      this.http.delete<UnitModel>(API_URL + API_UNIT_URL + '?_id=' + id, { headers: this.userService.getHttpAuthHeader() }).subscribe((data: any) => {
        if(callback){
          return callback();
        }
      });
    } */

    deleteUnit(id:string) {
      return this.http.delete<UnitModel>(API_URL + API_UNIT_URL + '?_id=' + id, { headers: this.userService.getHttpAuthHeader() });
    }

}
